import { STROLLER_QUESTION_SENT_TOAST } from 'mk/autogenerated/translations/StrollerAddQuestion.sagas.bf3691676dff66ea500c4bb88dbf1af0'
import { strollers_api_stroller_question_add_url } from 'mk/urls/functions';
import { STROLLER_ADD_QUESTION_FORM_NAME } from 'mk2/apps/strollers/containers/StrollerAddQuestion/QuestionAddForm';
import {
    strollerQuestionAddApi,
    StrollerQuestionAddNormalizedResponse,
    StrollerQuestionAddTriggerAction,
    STROLLER_ADD_QUESTION_TRIGGER,
} from 'mk2/apps/strollers/containers/StrollerAddQuestion/StrollerAddQuestion.actions';
import { strollersDetailUrl } from 'mk2/apps/strollers/urls';
import { XHRAction, XHRFormError } from 'mk2/helpers/api';
import { handleXHRFormErrorSaga, handleXHRFormSuccessSaga } from 'mk2/helpers/form';
import { url } from 'mk2/helpers/urls';
import { getLogger } from 'mk2/logger';
import { normalize } from 'normalizr';
import { all, call, put, takeLatest } from 'redux-saga/effects';

const logger = getLogger('strollers/StrollersAddQuestion.sagas');

interface ApiResponseStrollerAddQuestion {
    body: {};
}

function* submitQuestionSaga({ strollerSlug, questionFd, xhr }: StrollerQuestionAddTriggerAction & XHRAction) {
    yield put(strollerQuestionAddApi.request(strollerSlug));

    try {
        const response: ApiResponseStrollerAddQuestion = yield call(
            () => xhr.post(strollers_api_stroller_question_add_url(), {
                strollerSlug,
                questionFd,
            }),
        );
        const normalizedResponse: StrollerQuestionAddNormalizedResponse = normalize(response.body, {});

        const gotoUrl = url(strollersDetailUrl, {slug: strollerSlug});
        yield handleXHRFormSuccessSaga(STROLLER_ADD_QUESTION_FORM_NAME, gotoUrl, STROLLER_QUESTION_SENT_TOAST);
        yield put(strollerQuestionAddApi.success(strollerSlug, normalizedResponse));
    } catch (error) {
        yield handleXHRFormErrorSaga(STROLLER_ADD_QUESTION_FORM_NAME, error as XHRFormError, logger);
        yield put(strollerQuestionAddApi.failure(strollerSlug, error));
    }
}

export default function* root() {
    yield all([
        takeLatest(STROLLER_ADD_QUESTION_TRIGGER, submitQuestionSaga),
    ]);
}
